import { Component } from '@angular/core';

@Component({
  selector: 'app-section-titulo-cultura-colaborativa',
  templateUrl: './section-titulo-cultura-colaborativa.component.html',
  styleUrls: ['./section-titulo-cultura-colaborativa.component.scss'],
})
export class SectionTituloCulturaColaborativaComponent {}
